<template>
  <div class="login-card__verification-email">
    <h1 class="login-card__title">
      {{ trans.get('auth.card.verification.email.header') }}
    </h1>

    <div class="login-card__verification-icon">
      <i class="demo-icon icon-mail-sec"></i>
    </div>

    <div>
      <p class="login-card__verification-success" v-if="linkResent">
        {{ trans.get('auth.card.verification.email.link_successfully_resent') }}
      </p>
    </div>

    <p class="login-card__verification-desc">
      {{ trans.get('auth.card.verification.email.message') }}
    </p>

    <div class="login-card__buttons-box">
      <button
        type="button"
        class="button button__outline mb-2"
        @click="resendLink"
      >
        {{ trans.get('auth.card.buttons.resend_link') }}
      </button>


      <button
        type="button"
        class="button button__link button__link--underline"
        @click="logout"
      >
        {{ trans.get('auth.card.buttons.logout') }}
      </button>
    </div>

    <div
      class="login-card__btn-desc"
      v-html="trans.get('auth.card.registration_agreement', {link1: zRoute('page.agbn'), link2: zRoute('page.privacy')})"
    ></div>

  </div>
</template>
<script>
export default {
  props: ['swapComponent'],
  data: () => ({
    linkResent: false,
  }),
  methods: {
    resendLink() {
      const self = this;
      axios
        .post(zRoute('verification.email.resend'))
        .then(
          function (response) {
            self.linkResent = true;
          },
          function (error) {
            self.linkResent = false;
            if (error.response.status === 422) {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        );
    },
    logout() {
      const self = this;
      axios
        .post(zRoute('logout'))
        .then(function (response) {
          self.swapComponent('auth-welcome-card');
        });
    },
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then((response) => {
          const token = response.data.csrfToken;
          document
            .querySelector('meta[name=csrf-token]')
            .setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
  },
  activated() {
    this.linkResent = false;
    this.refreshCSRFToken();
  },
};
</script>
<style scoped>
</style>
